import React, { useState, useContext, useEffect } from "react";
import { DataContext } from "../../common/DataContext";
import { Header } from "../../components/Header";
import { Footer } from "../../components/Footer";
import { ShoppingCartModal } from "../../components/common";

export const FAQ = () => {
  const { cartOpen, toggleCartOpen, mobile, handleToggleCartOpen } =
    useContext(DataContext);

  const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    const faqItemStyle = {
      cursor: "pointer",
      marginBottom: mobile ? "5vh" : "2vh",
    };

    const faqQuestionStyle = {
      fontSize: mobile ? "1.25em" : "1.5em",
      margin: 0,
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      alignItems: "center",
    };

    const faqAnswerStyle = {
      marginTop: "10px",

      fontSize: "1em",
      color: "#333",
      textAlign: "center",
      whiteSpace: "pre-line", // This ensures that newline characters are rendered as line breaks
    };

    return (
      <div style={faqItemStyle} onClick={() => setIsOpen(!isOpen)}>
        <h2 style={faqQuestionStyle}>{question}</h2>
        {isOpen && <p style={faqAnswerStyle}>{answer}</p>}
      </div>
    );
  };

  const faqs = [
    {
      question: "What is your return policy?",
      answer:
        "Currently all products are sold as-is and all sales are final.\nIf you are unsatisfied with your purchase, please reach out to me at the support address on the contact page,\nand I will try my best to replace or upgrade your order or any items in it to your satisfaction if possible.",
    },
    {
      question: "How do I track my order?",
      answer:
        "When your order is  shipped, an email containing the tracking number for your order will be auto-generated and sent to the email address attached to your order.",
    },
    {
      question: "Do you offer international shipping?",
      answer:
        "Yes, however we presently only offer international shipping to a limited areas.",
    },
    {
      question: "How can I contact customer service?",
      answer:
        "Please reach out to us any time by email at statelystickers247@gmail.com \n I am generally available from 9-9 MST M-F snd will get back to you ASAP.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We currently use PayPal for all transactions.\n You may use your PayPal account or use the debit/credit card option which does not require an account.",
    },
    {
      question: "Why aren't there stickers for all of my state/s yet?",
      answer:
        "Short answer: There will be. \n Long Answer: I'm drawing all of the vector files myself from scratch and the states available represent those that...\n 1: I have gotten to and \n 2: have relatively simple geometric designs. \n Have you seen some of the rediculous detail on some state flags?\n It's total overkill, it's a state flag not a heraldic crest or whatever.\n Maybe tone it down guys and  just grab some shapes & colors \n and maybe the first letter of your state's name if you are feeling fiesty and work with that.",
    },
    {
      question: "What is the airspeed velocity of an unladen swallow?",
      answer:
        "An African or a European Swallow? \nEuropean Swallow - 11 meters per second (24 miles per hour) \n African Swallow - 9 to 12 meters per second (20 to 27 miles per hour)",
    },
  ];
  const faqPageStyle = {
    padding: "20px",
    backgroundColor: "#4EABDA",
    height: "100vh",
  };

  const faqColumnStyle = {
    height: "80vh",
    maxHeight: "90vh",
    overflowY: "auto",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  return (
    <>
      <Header />
      <ShoppingCartModal />
      <div style={faqPageStyle}>
        <div style={faqColumnStyle}>
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};
